import { atomFamily } from 'jotai/utils';
import type { FailedApiResponse } from 'components/well-page-content/types';
import { mutationAtomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import { CreateWorkspaceResponse, WorkspacesQueryResponse } from './types';
import { extractApiErrorMessage } from './utils';

export const workspacesCountAtomFamily = atomFamily((entityId: number) => {
  const [, loadableAtom] = mutationAtomWithLoadable<{ totalCount: number }>(
    async () => {
      const response = await request.post<
        WorkspacesQueryResponse,
        FailedApiResponse
      >(
        '/queries/interest_certification_workspaces',
        {
          query: {
            entity_id: entityId,
            page: 1,
            page_size: 1,
          },
        },
        new AbortController()
      );

      if (response.type === 'success' && response.data) {
        return { totalCount: response.data.totalCount };
      }

      throw new Error(
        extractApiErrorMessage(response, 'Failed to load workspaces count')
      );
    }
  );
  return loadableAtom;
});

export const [createWorkspaceAtom, createWorkspaceLoadableAtom] =
  mutationAtomWithLoadable<
    CreateWorkspaceResponse,
    [entityId: number, name: string, description?: string]
  >(async (_get, _set, entityId, name, description) => {
    const response = await request.post<
      CreateWorkspaceResponse,
      FailedApiResponse
    >(
      '/interest_certification/workspaces',
      {
        workspace: {
          entity_id: entityId,
          name,
          // Omit the key entirely when blank so the column stays null rather
          // than storing an empty string.
          ...(description ? { description } : {}),
        },
      },
      new AbortController()
    );

    if (response.type === 'success' && response.data) {
      return response.data;
    }

    throw new Error(
      extractApiErrorMessage(response, 'Failed to create workspace')
    );
  });
